import { rem } from "polished";
import styled from "styled-components";

import { ColorLabels } from "@/components/editor/utils/use-color";

export const StyledSponsorCard = styled.a`
  text-decoration: none;
  background: #fff;
  margin: 0 ${rem(12)} ${rem(24)} ${rem(12)};
`;

export const CardLogoContainer = styled.div`
  width: 100%;

  /* compensation for the ghost shadow */
  height: 100%;
  padding: ${rem(8)} ${rem(40)};
  display: grid;
  place-content: center;
`;

export const SponsorCardLogo = styled.img`
  object-fit: scale-down;
  width: 100%;

  /* compensation for the ghost shadow */
  height: ${rem(99)};
`;

export const SponsorCardText = styled.div`
  display: grid;
  place-content: center;
  text-align: center;
  width: 100%;
  font-weight: 700;
  font-size: ${rem(16)};
  line-height: ${rem(32)};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};

  /* compensation for the ghost shadow */
  padding: 0 ${rem(16)};
`;
